import editorErrorMessages from '@/constants/errorMessages/editorErrorMessages';

export default {
  data: () => ({
    isNotificationSentToFreeSubscribers: false,
    isNotificationSentToPaidSubscribers: false,
  }),
  computed: {
    emailOptions() {
      return [
        {
          label: 'Email free subscribers',
          value: 'freeSubscribers',
          disabled: this.getIsOptionDisabled(this.isNotificationSentToFreeSubscribers),
          tooltipMessage: this.getTooltipMessage(this.isNotificationSentToFreeSubscribers),
        },
        {
          label: 'Email paid subscribers',
          value: 'paidSubscribers',
          disabled: this.getIsOptionDisabled(this.isNotificationSentToPaidSubscribers),
          tooltipMessage: this.getTooltipMessage(this.isNotificationSentToPaidSubscribers),
        },
      ];
    },
  },
  methods: {
    getTooltipMessage(isNotificationSent) {
      if (isNotificationSent) {
        return editorErrorMessages.YOU_HAVE_ALREADY_SENT_MESSAGES;
      }

      if (!this.isSubscriptionWidgetEnabled) {
        return editorErrorMessages.NO_SUBSCRIPTION_WIDGET_IN_LINKS;
      }

      return '';
    },
    getIsOptionDisabled(isNotificationSent) {
      return isNotificationSent || !this.isSubscriptionWidgetEnabled;
    },
  },
  mounted() {
    this.isNotificationSentToFreeSubscribers = this.content.notificationSent.freeSubscribers;
    this.isNotificationSentToPaidSubscribers = this.content.notificationSent.paidSubscribers;
  },
};
